import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import SearchIcon from '../../../../assets/images/SearchIcon.svg';
import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {},
    listWrapper: {
      listStyleType: 'none',
      paddingLeft: 0,
    },
    filterTitle: {
      fontSize: 22,
      lineHeight: 1.2,
      marginBottom: SMALL_MARGIN,
      fontWeight: 'bold',
    },
    search: {
      width: '100%',
      marginBottom: SMALL_MARGIN,
      padding: 10,
      paddingLeft: 45,
      fontSize: 16,
      color: colorsPalette.gray,
      background: theme.palette.secondary.light,
      borderRadius: 5,
      border: 'none',
      backgroundImage: `url(${SearchIcon})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '15px 50%',
      '&:focus': {
        outline: 'none',
      },
    },
    showMoreBtn: {
      background: 'transparent',
      border: 'none',
      fontWeight: 'bold',
      color: colorsPalette.gray,
      cursor: 'pointer',
      marginBottom: SMALL_MARGIN,
      marginTop: SMALL_MARGIN,
      fontSize: 16,
      '&:focus': {
        outline: 'none',
      },
    },
    noItems: {
      color: colorsPalette.gray,
      fontSize: 16,
    },
  }),
);

export const useBtnStyles = (listIsOpen) =>
  makeStyles(() =>
    createStyles({
      btn: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        backgroundColor: colorsPalette.blueDark,
        border: 'none',
        alignSelf: 'flex-start',
        zIndex: 2,
        marginTop: -1,
        '&:focus': {
          outline: 'none',
        },
        padding: '5px 0',
      },
      text: {
        fontSize: 16,
        fontWeight: 'bold',
        color: colorsPalette.gray,
      },
      icon: {
        width: 16,
        height: 16,
        cursor: 'pointer',
        transform: listIsOpen ? 'none' : 'rotate(180deg)',
        transition: 'transform 0.3s ease-out',
        marginLeft: SMALL_MARGIN,
      },
    }),
  );

export default useStyles;
